import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Booking } from '../booking';
import { BookingService } from '../service/booking.service';
import { BrugesVndBooking } from '../bruges-vnd-booking';
import { HttpService } from '../service/http.service';
import { ToastMessageService } from '../toast-message.service';
import { UserService } from '../service/user.service';
import { BookingBrugesService } from '../service/booking-bruges.service';

@Component({
  selector: 'app-edit-booking-bruges-vnd',
  templateUrl: './edit-booking-bruges-vnd.component.html',
  styleUrls: ['./edit-booking-bruges-vnd.component.css']
})
export class EditBookingBrugesVndComponent implements OnInit {

  img: HTMLImageElement = new Image();
  pictureLoaded: boolean = false;
  canvasBlob!: Blob | null;
  fileToUpload: File | null = null;
  dashboardUrl!: string;
  booking!: BrugesVndBooking;
  loadingStudentPicture = false;
  pictureUploading = false;

  @ViewChild("myCanvas", { static: true }) myCanvas!: ElementRef;
  context!: CanvasRenderingContext2D;

  constructor(
    public bookingService: BookingService,
    private httpService: HttpService,
    public userService: UserService,
    private messageService: ToastMessageService,
    public bookingBrugesService: BookingBrugesService
  ) { }

  ngOnInit(): void {
    this.booking = this.bookingService.booking as BrugesVndBooking;
    this.dashboardUrl = "https://languesvivantes-bruges.com/" + this.bookingBrugesService.getPathByStudentLanguage(this.bookingService.booking.student.language) + "/dashboard/" + this.bookingService.booking.uuid;
  }

  ngAfterViewInit() {
    this.addBrugesInfo(this.booking);
  }

  drawResizedImage() {
    let ratio = this.img.width / this.img.height;
    let adjustedImgWidth = 0;
    let adjustedImgHeight = 0;
    // landscape photo (width > height)
    if (ratio >= 1) {
      let maxWidth = 300;
      if (this.img.width > maxWidth) {
        adjustedImgWidth = maxWidth;
        adjustedImgHeight = maxWidth / ratio;
        this.myCanvas.nativeElement.width = adjustedImgWidth;
        this.myCanvas.nativeElement.height = adjustedImgHeight;
      } else {
        this.myCanvas.nativeElement.width = this.img.width;
        this.myCanvas.nativeElement.height = this.img.height;
      }
      // portrait photo (height > width)
    } else {
      let maxHeight = 320;
      if (this.img.height > maxHeight) {
        adjustedImgHeight = maxHeight;
        adjustedImgWidth = maxHeight * ratio;
        this.myCanvas.nativeElement.width = adjustedImgWidth;
        this.myCanvas.nativeElement.height = adjustedImgHeight;
      } else {
        this.myCanvas.nativeElement.width = this.img.width;
        this.myCanvas.nativeElement.height = this.img.height;
      }
    }
    this.context.drawImage(this.img, 0, 0, this.myCanvas.nativeElement.width, this.myCanvas.nativeElement.height);
  }

  handleFileInput(event: any) {
    if (event.target.files && event.target.files[0]) {
      this.fileToUpload = event.target.files[0];
      let reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = (event: any) => {
        this.img.src = event.target.result;
        this.img.onload = () => {
          const sizeRatio = this.img.width / this.img.height;
          let resizedHeight = this.img.height;
          let resizedWidth = this.img.width;

          if (sizeRatio < 1 && 300 < this.img.height) {
            resizedHeight = 300;
            resizedWidth = 300 * sizeRatio;
          }
          if (sizeRatio >= 1 && this.img.width > 320) {
            resizedWidth = 320;
            resizedHeight = 320 / sizeRatio;
          }

          this.myCanvas.nativeElement.width = resizedWidth;
          this.myCanvas.nativeElement.height = resizedHeight;
          this.context.drawImage(this.img, 0, 0, resizedWidth, resizedHeight);
        }
      }
    }
  }

  hideCanvas(){
    this.myCanvas.nativeElement.width = 0;
    this.myCanvas.nativeElement.height = 0;
  }

  uploadFile() {
    if(this.loadingStudentPicture || this.pictureUploading){
      return;
    }
    this.hideCanvas();
    this.pictureUploading = true;
    let formToSend = new FormData();
    formToSend.append("file", this.fileToUpload!);
    this.httpService.postStudentPicture(formToSend, this.booking.uuid!)
      .subscribe(() => {
        this.fileToUpload = null;
        this.pictureLoaded = true;
        this.messageService.addSuccess("Success", "Picture uploaded");
        this.bookingBrugesService.hasNoPicture = false;
        this.pictureUploading = false;
        this.setStudentPictureFromDatabase(this.booking);
      },
        error => {
          this.pictureLoaded = false;
          this.fileToUpload = null;
          this.messageService.addError("Error", "Picture not uploaded");
          this.pictureUploading = false;
        }
      );
  }
  updateFile() {
    if(this.loadingStudentPicture || this.pictureUploading){
      return;
    }
    this.pictureUploading = true;
    this.hideCanvas();
    let formToSend = new FormData();
    formToSend.append("file", this.fileToUpload!, this.bookingService.booking.id!.toString());
    this.httpService.putStudentPicture(formToSend, this.booking.uuid!)
      .subscribe(picture => {
        this.fileToUpload = null;
        this.pictureLoaded = true;
        this.canvasBlob = null;
        this.messageService.addSuccess("Success", "Picture is updated");
        this.pictureUploading = false;
        this.setStudentPictureFromDatabase(this.booking);
      },
        error => {
          this.fileToUpload = null;
          this.messageService.addError("Error", "Picture not updated");
          this.pictureUploading = false;
        }
      );
  }

  downloadPdf(booking: Booking) {
    booking.downloading = true;
    this.httpService.getPdfBlob(booking.id!, booking.student.language.name).subscribe(blob => {
      let pdfUrl = window.URL.createObjectURL(blob);
      let link = document.createElement("a");
      link.href = pdfUrl;
      link.download = "Vademecum " + booking.student.lastName + " " + booking.student.firstName + ".pdf";
      link.click();
      booking.downloading = false;
    });
  }

  addBrugesInfo(brugesVndBooking: BrugesVndBooking) {
    if (brugesVndBooking.studentPicture) {
      this.setStudentPictureFromMemory(brugesVndBooking);
    } else {
      if(!this.bookingBrugesService.hasNoPicture){
        this.setStudentPictureFromDatabase(brugesVndBooking);
      }
    }

    this.setVademecum(brugesVndBooking);
  }

  setStudentPictureFromMemory(brugesVndBooking: BrugesVndBooking) {
    this.context = (<HTMLCanvasElement>this.myCanvas.nativeElement).getContext("2d")!;
    this.img.src = URL.createObjectURL(brugesVndBooking.studentPicture!);
    this.img.onload = () => {
      this.drawResizedImage();
    }
  }

  setStudentPictureFromDatabase(brugesVndBooking: BrugesVndBooking) {
    this.loadingStudentPicture = true;
    this.context = (<HTMLCanvasElement>this.myCanvas.nativeElement).getContext("2d")!;
    this.httpService.getStudentPictureByUuid(this.booking.uuid!).subscribe(blob => {
      if (blob.size > 0) {
        this.pictureLoaded = true;
        brugesVndBooking.studentPicture = blob;
        this.img.src = URL.createObjectURL(brugesVndBooking.studentPicture);
        this.img.onload = () => {
          this.drawResizedImage();
          this.loadingStudentPicture = false;
        }
        //booking has no picture of student
      } else {
        this.pictureLoaded = false;
        brugesVndBooking.studentPicture = null;
        this.bookingBrugesService.hasNoPicture = true;
        this.loadingStudentPicture = false;
      }
    });
  }
  setVademecum(brugesVndBooking: BrugesVndBooking) {
    this.httpService.getVademecumByBookingId(this.booking.id!).subscribe(vadm => {
      brugesVndBooking.vademecum = vadm;
    });
  }

}
